import { apiPost } from '../../api'

export const save_venue = data =>
  apiPost({
    endpoint: 'venue/save_venue',
    data
  })
